import { authenticationService } from '@/services/authentication';

/**
 * Verifica se o usuário tem pelo menos uma das permissões especificadas
 * @param permissions Array de permissões a verificar
 * @returns true se o usuário tem pelo menos uma permissão, false caso contrário
 */
export async function checkPermissions(
  permissions: string[]
): Promise<boolean> {
  try {
    const session = await authenticationService.getAuthSession();
    if (!session) return false;

    const permission = session.payload.permissions;
    if (!permission) return false;

    let userPermissions: string[];
    if (Array.isArray(permission)) {
      userPermissions = permission as string[];
    } else if (typeof permission === 'string') {
      // Tenta JSON.parse, se falhar usa split por vírgula
      try {
        userPermissions = JSON.parse(permission) as string[];
      } catch {
        userPermissions = permission.split(',').map(p => p.trim());
      }
    } else {
      return false;
    }

    return permissions.some(p => userPermissions.includes(p));
  } catch (error) {
    console.error('Erro ao verificar permissões:', error);
    return false;
  }
}

/**
 * Verifica permissões e redireciona se o usuário não tiver acesso
 * Útil para usar em beforeLoad ou loader do TanStack Router
 * @param permissions Array de permissões a verificar
 * @param redirectTo Rota para redirecionar se não tiver permissão (padrão: '/dashboard')
 * @throws redirect se o usuário não tiver permissão
 */
export async function requirePermissions(
  permissions: string[]
): Promise<boolean> {
  const hasPermission = await checkPermissions(permissions);
  return hasPermission;
}
